import styled from "styled-components"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"

const StyledLink = styled(TransitionFade)`
  &::before {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark}61;
  }
  color: black;
`
const StyledExternalLink = styled.a`
  color: black;
`

export { StyledLink, StyledExternalLink }
